
import { useStore } from 'vuex'
import { computed, defineComponent, reactive, toRefs } from 'vue'
export default defineComponent({
  name: 'location',
  components: {},
  emits: ['toggleSelectCitySideBar'],
  props: {
    bgColor: {
      type: String
    }
  },
  setup(props,{emit}) {
      const store = useStore()
      const data = reactive({
       locationInfo: computed(() => store.state.locationInfo),
    })
    
    const methods = {
      toggleSelectCitySideBar() {
        emit('toggleSelectCitySideBar', true)
      }
    }
    return {
      ...toRefs(data),
      ...methods
    }
  },
})
